import { environment } from 'src/environments/environment';

export function metaReportUrl(reportId: number): string {
  return `${environment.config.digitalIntelligence.domain}/meta/report/${reportId}`;
}

export function metaReportTabUrl(reportId: number, tab: string): string {
  return `${metaReportUrl(reportId)}/${tab}`;
}
